<h3>Spezifikationsgrundlage</h3>
<p [attr.data-testid]="testIds.productProductId">ID: {{ productId }}</p>
<p [attr.data-testid]="testIds.productProductType">Produkttyp: {{ productType }}</p>
<p [attr.data-testid]="testIds.productApplicationName">Anwendungsname: {{ applicationName }}</p>
<p [attr.data-testid]="testIds.productProductTypeVersion">Produkttypversion: {{ productTypeVersion }}</p>

<h3>Produktidentifikation</h3>
<p [attr.data-testid]="testIds.productProducerId">Hersteller-/Anbieter-ID: {{ producerId }}</p>
<p [attr.data-testid]="testIds.productProductShortName">Produktkürzel: {{ productShortname }}</p>
<p [attr.data-testid]="testIds.productProductVersion">Produktversion: {{ productVersion }}</p>

<h3>Zusätzliche Produktattribute</h3>
<p [attr.data-testid]="testIds.productProducerName">Herstellername: {{ producerName }}</p>
<p [attr.data-testid]="testIds.productProductName">Produktname: {{ productName }}</p>

<div class="clock" aria-live="polite" [attr.data-testid]="testIds.clock">
  {{ time$ | async | date: 'EEE, dd.MM.yyyy HH:mm:ss' : 'Europe/Berlin' }} Uhr
</div>
